/* esm.sh - class-variance-authority@0.7.1 */
export * from "/*class-variance-authority@0.7.1/esnext/class-variance-authority.mjs";
